import T from 'T'
import { get } from 'lodash'
import { createDateFromString, formatDateToFEFormatDateFns } from '../../utils/date'
import { formatCentsToDollars } from '../../utils/price'
import { getPaymentMethod } from '../../utils/payment'
import { PAYMENT_STATUS } from '../../settings/constants/payment'

// eslint-disable-next-line import/no-cycle
import { convertDateTimeToPreferedTimezone } from '../../data/dateTime/convertDateTimeToPreferedTimezone'

const { TRANSFERRED } = PAYMENT_STATUS

const dateValueFormatter = value => {
  if (!value) return ''
  return formatDateToFEFormatDateFns(createDateFromString(value))
}

const dateTimeValueFormatter = value => {
  if (!value) return ''
  const { fullDateTime } = convertDateTimeToPreferedTimezone({ dateTime: value, defaultZone: 'America/Los_Angeles' })
  return fullDateTime
}

const moneyValueFormatter = value => {
  if (!value) return ''
  return formatCentsToDollars(value)
}

const yesNoFormatter = value => {
  if (!value) return 'No'
  return 'Yes'
}

const paymentMethodFormatter = value => {
  if (!value) return ''
  return getPaymentMethod(value)
}

const transactionStatusFormatter = value => {
  const status = value
  if (!status) return ''
  if (status === TRANSFERRED) return T.TRANSFER
  return status
}

const tagsObjToStringFormatter = value => {
  if (!value) return ''
  const accountTags = get(value, 'forAccount', [])?.map(tag => tag?.tagName)
  const serviceTags = get(value, 'forService', []).map(tag => tag?.tagName)
  const locationTags = get(value, 'forLocation', []).map(tag => tag?.tagName)

  // Combine all tags and join with commas
  const allTags = [...accountTags, ...serviceTags, ...locationTags]
  return allTags.join(', ')
}

export {
  dateTimeValueFormatter,
  dateValueFormatter,
  moneyValueFormatter,
  yesNoFormatter,
  paymentMethodFormatter,
  transactionStatusFormatter,
  tagsObjToStringFormatter,
}
